import React, { FC, useState } from 'react'

export interface NavContextProps {
  footerInView: boolean
  activeSlide: number
  menuOpened: boolean
  menuClosed: boolean
  userInteracted: boolean
  acceptCookies: boolean
  currentSlide: number
  setFooterInView: (isInView: boolean) => void
  setUserInteracted: (isInView: boolean) => void
  setActiveSlide: (value: number) => void
  setMenuOpened: (isOpened: boolean) => void
  setMenuClosed: (isOpened: boolean) => void
  setCurrentSlide: (value: number) => void
  setConsentCookies: (value: boolean) => void
  setFilters: (filters: any[]) => void
  toggleMenu: () => void
  isTouchDevice: () => boolean
  isMobile: () => boolean
  filters: any[]
}

const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0));
};

const isBrowser = () => typeof window !== "undefined";

const isMobile = () => isBrowser() && window?.innerWidth < 992;

const NavContext = React.createContext<NavContextProps>({
  footerInView: false,
  userInteracted: false,
  activeSlide: 0,
  menuOpened: false,
  menuClosed: null,
  currentSlide: null,
  acceptCookies: null,
  filters: [],
  setFooterInView: () => {},
  setUserInteracted: () => {},
  setActiveSlide: () => {},
  setMenuOpened: () => {},
  setMenuClosed: () => {},
  setCurrentSlide: () => {},
  setFilters: () => {},
  setConsentCookies: () => {},
  toggleMenu: () => {},
  isTouchDevice,
  isMobile,
})

export const NavProvider: FC = ({ children }) => {
  const [footerInView, setFooterInView] = useState<boolean>(false)
  const [menuOpened, setMenuOpened] = useState<boolean>(false)
  const [menuClosed, setMenuClosed] = useState<boolean>(null)
  const [acceptCookies, setConsentCookies] = useState<boolean>(null)
  const [userInteracted, setUserInteracted] = useState<boolean>(false)
  const [currentSlide, setCurrentSlide] = useState<number>(null)
  const [activeSlide, setActiveSlide] = useState<number>(0)
  const [filters, setFilters] = useState<any[]>([])
  const toggleMenu = () => {
    if (!menuOpened === true) {
      window.dataLayer.push({
        event: "click_menu",
        url: window.location.pathname
      });
    }
    setMenuOpened(!menuOpened)
    if (menuClosed === null) {
      setMenuClosed(false)
    } else {
      setMenuClosed(!menuClosed)
    }
  };

  const value: NavContextProps = {
    footerInView,
    userInteracted,
    activeSlide,
    menuOpened,
    menuClosed,
    currentSlide,
    acceptCookies,
    filters,
    setFooterInView,
    setUserInteracted,
    setActiveSlide,
    setMenuOpened,
    setMenuClosed,
    setCurrentSlide,
    setConsentCookies,
    setFilters,
    toggleMenu,
    isTouchDevice,
    isMobile
  }

  return <NavContext.Provider value={value}>{children}</NavContext.Provider>
}

export default NavContext
